"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customDateRangeTranslations = {
    "en": {
        startDate: "Start Date",
        endDate: "End Date",
        time: "Time",
        displayDataBy: "Display data by:",
        cancel: "Cancel",
        apply: "Apply",
        reset: "Reset",
        validationMessage1: "Start Date/Time cannot be",
        validationMessage2: "End Date/Time",
        after: "after",
        sameAs: "the same as",
    },
    "de": {
        cancel: "Abbrechen",
        displayDataBy: "Anzeigen der Daten nach:",
        validationMessage2: "Enddatum / -zeit",
        validationMessage1: "Startdatum / -zeit kann nicht",
        endDate: "Enddatum",
        apply: "Anwenden",
        reset: "Zurücksetzen",
        time: "Zeit",
        after: "nach",
        startDate: "Startdatum",
        sameAs: "gleich wie",
    },
    "nl": {
        cancel: "Annuleren",
        displayDataBy: "Data weergeven op:",
        validationMessage2: "Einddatum/-tijd",
        validationMessage1: "Startdatum/-tijd mag niet",
        endDate: "Einddatum",
        apply: "Toepassen",
        reset: "Resetten",
        time: "Tijd",
        after: "na",
        startDate: "Startdatum",
        sameAs: "dezelfde als",
    },
    "it": {
        cancel: "Annulla",
        displayDataBy: "Mostra dati per:",
        validationMessage2: "Data/ora di fine",
        validationMessage1: "La data/ora di inizio non può essere",
        endDate: "Data di fine",
        apply: "Applica",
        reset: "Reimposta",
        time: "Orario",
        after: "dopo",
        startDate: "Data di inizio",
        sameAs: "lo stesso di",
    },
    "fr": {
        cancel: "Annuler",
        displayDataBy: "Afficher les données selon:",
        validationMessage2: "Date/heure de fin",
        validationMessage1: "La date et l'heure de début ne peuvent pas être",
        endDate: "Date de fin",
        apply: "Appliquer",
        reset: "Réinitialiser",
        time: "Heure",
        after: "après",
        startDate: "Date de début",
        sameAs: "comme",
    },
    "es": {
        cancel: "Cancelar",
        displayDataBy: "Visualizar los datos por:",
        validationMessage2: "Fecha/Hora de finalización",
        validationMessage1: "Fecha/Hora de inicio no puede ser",
        endDate: "Fecha de finalización",
        apply: "Aplicar",
        reset: "Reiniciar",
        time: "Hora",
        after: "después",
        startDate: "Fecha de inicio",
        sameAs: "igual a",
    },
    "ja": {
        cancel: "キャンセル",
        displayDataBy: "表示データの順序：",
        validationMessage2: "終了日/終了時刻",
        validationMessage1: "以下の開始日/開始時間は選べません：",
        endDate: "終了日",
        apply: "適用",
        reset: "リセット",
        time: "時刻",
        after: "経過後",
        startDate: "開始日",
        sameAs: "以下と同じ",
    },
    "en-GB": {
        cancel: "Cancel",
        displayDataBy: "Display data by:",
        validationMessage2: "End Date/Time",
        validationMessage1: "Start Date/Time cannot be",
        endDate: "End Date",
        apply: "Apply",
        reset: "Reset",
        time: "Time",
        after: "after",
        startDate: "Start Date",
        sameAs: "the same as",
    },
    "ru": {
        startDate: "Начальная Дата",
        endDate: "Конечная Дата",
        time: "Время",
        displayDataBy: "Отображать промежуток по:",
        cancel: "Отменить",
        apply: "Применить",
        reset: "Сбросить",
        validationMessage1: "Начальная Дата/Время не может быть",
        validationMessage2: "Конечная Дата/Время",
        after: "после",
        sameAs: "такой же как",
    },
};
